import * as format from '../data/format';
import { CATEGORY, SERIES, VALUE, POINT } from '../data/constants';
import getPoint from '../data/getPoint';
import isFinite from 'lodash.isfinite';
import { replaceLineBreaks, boldText } from '../util/element';

export function preRender(data, options) {
  return data;
}

export function postRender(highchart, options) {
  const result = {
    yTop: 0,
    yBot: 0,
    items: null,
  };
  if (chartTypeOk(options)) {
    // render text with proper styles
    result.items = renderAnnotations(highchart, options, options.annotations.items);
    // set spacing value to allow room for annotations at top of chart
    if (result.items.length) {
      updateYTop(result, options);
      // updateYBot(result, options);
    }
  }
  return result;
}

export const defaults = {
  type: 'lines',
  showLine: true,
  lineEnd: null,
  textAlign: 'left',
  flushAlign: 'flush',
};

function updateYTop(result, options) {
  const lineHeight = options.product === 'wsj' && !options.print ? 24 : parseFloat(options.styles.normal.lineHeight);
  let maxHeight = 0;
  result.items.forEach((item, index) => {
    // This works because the only child nodes should be <tspan>s.
    maxHeight = Math.max(maxHeight,
      (item.element.children.length - 1) * lineHeight);
  });
  result.yTop = maxHeight;
}

// function updateYBot(result) {
//   const itemsLen = result.items.length;
//   let maxHeight = 0;
//   if (itemsLen > 3) {
//     for (let i = 1; i < itemsLen; i += 2) {
//       const itemHeight = result.items[i].element.getBoundingClientRect().height;
//       maxHeight = Math.max(itemHeight, maxHeight);
//     }
//   }
//   result.yBot = maxHeight;
// }

function renderAnnotations(highchart, options, items) {
  const margin = 10;
  const itemWidth = getItemWidth(options, items);
  const css = options.styles.get('normal');
  if (__FINANCIALNEWS__) {
    if (options.product === 'financialnews') {
      if (options.print === true && options.sizes['print-fn'].columns <= 2) {
        css.fontSize = 8.5;
      }
    }
  }
  css.width = `${itemWidth}px`;
  const lineHeight = parseFloat(css.lineHeight);
  items.some((item, index) => {
    item.element = renderItemText(highchart, options, item, itemWidth, css);
  });
  return items;
}

function getItemWidth(options, items) {
  const itemsLen = items.length;
  if (itemsLen === 1) {
    return options.width * 0.67;
  } else if (itemsLen === 2) {
    return options.width * 0.5;
  } else if (itemsLen >= 3) {
    return options.width * 0.33;
  }
  return 0;
}

function renderItemText(highchart, options, item, itemWidth, css) {
  const text = compileText(item, options);
  const textBr = replaceLineBreaks(text);
  const render = highchart.renderer.text(textBr, 0, 0).css(css).add();
  const wsjFont = options.product === 'wsj' ? 'Retina' : options.styles.font.bold;
  // bold any text bracketed by **
  const openTag = `<tspan font-family='${wsjFont}' font-weight="${options.styles.weight.bold}">`;
  const closeTag = `</tspan>`;
  const tspans = [...render.element.querySelectorAll('tspan')];
  const boldAnnotation = boldText();
  tspans.forEach((tspan, i) => {
    const tspanStr = tspan.innerHTML.toString();
    tspan.innerHTML = boldAnnotation(tspanStr, openTag, closeTag);
    // move all tspans up except for the first one;
    if (__WSJ__) {
      if (options.product === 'wsj') {
        if(i !== 0){
          const offset = (options.print) ? 0 : 2;
          const dy = tspan.getAttribute('dy');
          tspan.setAttribute('dy', +dy + offset);
        }
      }
    }
  })
  return render.element;
}

function compileText(item, options) {
  return (item.text || '')
    .replace(/\\{/g, '__LEFT_BRACKET__')
    .replace(/\\}/g, '__RIGHT_BRACKET__')
    .replace(CATEGORY, compiledCategory(item, options))
    .replace(SERIES, compiledSeries(item, options))
    .replace(VALUE, compiledValue(item, options))
    .replace(POINT, compiledPoint(item, options))
    .replace(/__LEFT_BRACKET__/g, '{')
    .replace(/__RIGHT_BRACKET__/g, '}');
}

function compiledCategory(item, options) {
  if (item.attach.category.enabled) {
    return options.longCategories[item.attach.category.index];
  } else {
    return options.longCategories[item.attach.point.index];
  }
}

function compiledSeries(item, options) {
  const p = item.attach.point;
  if (p.enabled && options.series[p.series]) {
    return options.series[p.series].name || 'n/a';
  }
  return '{series}';
}

function compiledValue(item, options) {
  const p = item.attach.point;
  if (p.enabled && options.series[p.series]) {
    const point = getPoint(options.series[p.series], p.index);
    return point ? point.y : 'n/a';
  }
  return '{value}';
}

function compiledPoint(item, options) {
  const p = item.attach.point;
  if (p.enabled && options.series[p.series]) {
    const point = getPoint(options.series[p.series], p.index);
    if (point && isFinite(point.y)) {
      return format.applyFull(point.y, options.tooltips, options.type === 'pie', true, true);
    }
    return 'n/a';
  }
  return '{point}';
}

function chartTypeOk(options) {
  const { type, stacking } = options;
  return (type === 'column' && !stacking) || type === 'area' ||
    type === 'line';
}



// WEBPACK FOOTER //
// ./src/chart/outer/annotations.js